import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

// Ng-Bootstrap
import { NgbModule, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';

// Translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateConfig } from 'app/config/translate.config';

// Toastr
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { ToastrConfig } from 'app/config/toastr.config';

// App
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Shared
import { GlobalsService } from 'app/common/services/globals.service';
import { HttpInterceptorService, MRMErrorHandler, DatepickerAdapterConfig, ProgressBarService, PersistData } from '@mrm/core';
import { environment } from 'app/../environments/environment';
import { HeaderComponent } from './common/components/header/header.component';
import { EMREGCommonModule } from './common/emreg-common.module';
import { HeaderService } from './common/components/header/header.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    EMREGCommonModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (TranslateConfig.createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot(ToastrConfig.getConfig()),
  ],
  providers: [
    ToastrService,
    GlobalsService,
    MRMErrorHandler,
    {
      provide: ErrorHandler,
      useClass: MRMErrorHandler,
      deps: [HttpClient]
    },
    { provide: NgbDateAdapter, useClass: DatepickerAdapterConfig },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    { provide: 'InterceptorOptions', useValue: { updateUrl: environment.api, ignoreUrls: [environment.netApiUrl, environment.api, './assets'] } },
    ProgressBarService,
    PersistData,
    { provide: 'AppLookups', useClass: GlobalsService },
    { provide: 'Environment', useValue: environment },
    HeaderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
